<template>
  <div>
    <slot name='title' />
    <div>
      <div class="navless-layout-header">
        <slot name='navbar'>
          <ed-button :to='$routerHistory.previous().path'>
            <i class="fal fa-chevron-left"></i>
            &nbsp;
            {{ cannotBeReconciled || transactionComplete ? 'Back' : 'Cancel' }}
          </ed-button>
          <a
            v-if="!cannotBeReconciled && (isUserAdmin || reconcileAction !== 'view')"
            :endpoint='api.$.evedpaycard.reconcile'
            class="pull-right form-group list submit-btn"
            @click='confirm'
          >
            <strong>Save</strong>
          </a>
        </slot>
      </div>
      <br />

      <!-- Not allowed -->
      <div v-if='cannotBeReconciled'>
        <br />
        <ed-notice type='danger' icon='fas fa-exclamation-circle'>
          Transaction Declined: {{ transaction.data.DeclineReason }}
        </ed-notice>
      </div>

      <!-- Complete -->
      <div v-if='transactionComplete'>
        <br />
        <ed-notice type='alt' icon='fas fa-check-circle'>
          This transaction was submitted in envelope {{ transaction.data.EnvelopeNumber }}
        </ed-notice>
      </div>

      <div class="card">
        <ed-notice class='card'>
          <div class='details'>
            <div class="row">
              <div class="col-xs-9">
                <p class="overflow-merchant"><strong>{{ transaction.data.merchant }}</strong></p>
                <p><small>{{ moment(transaction.data.date).format('YYYY-MM-DD') }}</small></p>
              </div>
              <div class="col-xs-3">
                <p style="text-align:right"><strong><v-money>{{ transaction.data.amount }}</v-money></strong></p>
              </div>
            </div>
          </div>
        </ed-notice>
      </div>

      <!-- Not allowed -->
      <div v-if="cannotBeReconciled">
        <p>
          <strong>Card Holder</strong>
          <br />
          <small style="margin-left:10px;">{{ transaction.data.Holder }}</small>
        </p>
        <p>
          <strong>Card Number</strong>
          <br />
          <small style="margin-left:10px;">{{ transaction.data.CardNumber }}</small>
        </p>
        <p>
          <strong>{{ divisionName }}</strong>
          <br />
          <small style="margin-left:10px;">{{ transaction.data.Division }}</small>
        </p>
      </div>

      <div v-if='!cannotBeReconciled'>
        <Reconcile
          class="reconcile-form"
          v-if="transaction.data.DivisionId"
          :transaction="transaction"
          :fields-incomplete="{ receiptIncomplete, descriptionIncomplete }"
          :wrong-split-total="wrongSplitTotal"
          :reconcile-action="reconcileAction"
          @reconcile-created="handleReconcileCreated"
          @fields-updated="handleFieldsUpdated"
          @mediaFilesPathUpdated="updateMediaFilesPath"
          @attachmentsUpdated="updateAttachmentsFiles"
          @split-amounts="handleSplitAmounts"
          @description-text="handleDescriptionText"
          ref="reconcileComp"
        />
      </div>
      <br /><br />
    </div>
  </div>
</template>

<script>

import Reconcile from '@/components/_modules/Programs/Card-transactions/ReconcileTransaction'
import CardTransactions from '@/components/_modules/Programs/Card-transactions'
import { singularize } from '@/core/utils/string.js'
import { EventBus } from '@/event-bus'
const transactions = []

const { methods: transactionsMethods } = CardTransactions
const { methods: reconcileMethods } = Reconcile

export default {
  alias: 'evedpaytransactiondetails',
  components: {
    Reconcile
  },
  created() {
    this.divisionName = singularize(this.$root.getUser.sessionSettings.CompanySettings.Labels.DivisionName)
    this.hasBu = this.$root.getUser.settings.HasBusinessUnit
    this.hasCc = this.$root.getUser.settings.HasCostCenter
    this.hasBuAndCcPair = this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping

    const Id = this.$route.query.transactionid

    this.api.forms.post(this.api.$.evedpaycard.transactions, {
      sort: 'TransactionStatus',
      dir: 'ASC',
      start: 0,
      limit: 1000,
      isLiveGrid: true,
      filter: JSON.stringify({ 'Id': Id, searchTerm: '' })
    }).then(r => {
      this.transactions = r.data.Data.map(transaction => ({
        ...transaction,
        merchant: transaction.Merchant,
        amount: transaction.Amount,
        date: transaction.TransactionDate,
        status: transaction.TransactionStatus,
        reconcileStatus: transaction.ReconciliationStatus,
        id: transaction.Id
      }))

      this.transaction.data = this.transactions[0] || {}

      this.selectedProgram = {
        Id: this.transaction.data.ProgramId,
        Name: this.transaction.data.ProgramName
      }

      this.handleTransaction(this.transaction)

      this.transaction.data.ProgramId && this.getCategoriesAndBuAndCc(this.transaction.data.ProgramId)
    })
  },
  data() {
    return {
      transactions,
      hasBu: false,
      hasCc: false,
      hasBuAndCcPair: false,
      programs: [],
      programOptions: [],
      businessUnits: [],
      costCenters: [],
      buAndCcPairs: [],
      categories: [],
      supplierIncomplete: false,
      programIncomplete: false,
      requireReceiptDescription: Boolean,
      descriptionIncomplete: false,
      receiptIncomplete: false,
      buAndCcPairIncomplete: [],
      buIncomplete: [],
      ccIncomplete: [],
      categoryIncomplete: [],
      form: [{}],
      selectedProgram: {},
      selectedSupplier: {},
      selectedCategory: [],
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      itemIds: [],
      referenceId: [],
      filteredAttachments: [],
      wrongSplitTotal: false,
      noteText: '',
      selectedCardId: null,
      selectedTransactionId: null,
      hasErrors: false,
      reconcileAction: 'create',
      divisionName: '',
      transaction: { data: {} },
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      approvalUsersData: [],
      transactionInEnvelopeStatuses: ['In Envelope', 'Exported', 'Posted']
    }
  },
  computed: {
    cannotBeReconciled() {
      return this.transaction.data.status === 'Declined'
    },
    transactionComplete() {
      return this.transactionInEnvelopeStatuses.includes(this.transaction.data.status) && (this.transaction.data.reconcileStatus === 'Approved' || this.transaction.data.reconcileStatus === 'Coded')
    },
    moment() { return global.moment },
    programName() {
      return this.$root.getUser.settings.Labels.ProgramLabel
    },
    isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true
      }
      return false
    }
  },
  methods: {
    ...reconcileMethods,
    ...transactionsMethods,
    async confirm() {
      this.hasErrors = false
      await transactionsMethods.createReconcile.call(this)
      EventBus.$emit('transaction-reconciled', this.$route.query.transactionid)
      !this.hasErrors ? this.$router.go(-1) : void 0
    },
    stopSave() {
      this.hasErrors = true
    },
    async handleTransaction(transaction) {
      if (transaction && transaction.data) {
        this.selectedCardId = transaction.data.CardId
        this.selectedTransactionId = transaction.data.Id
        if (this.waitingApprovalStatuses.includes(transaction.data.EnvelopeStatus)) {
          await this.getApprovalUsers(transaction.data.EnvelopeId)
        }
        await this.handleReconcileAction(transaction)
      } else {
        this.reconcileAction = 'create'
      }
      this.showReconcile = true
      this.highlightedTransactionId = transaction.data.Id
    },
    async handleReconcileAction(transaction) {
      if (transaction.data.ReconciliationStatus !== 'Open') {
        if (transaction.data.ReconciliationStatus === 'Coded') {
          if (transaction.data.EnvelopeStatus === 'Draft') {
            this.reconcileAction = 'edit'
          } else if (!this.transactionInEnvelopeStatuses.includes(transaction.data.TransactionStatus) || this.isUserInApprovalList()) {
            this.reconcileAction = 'edit'
          } else {
            this.reconcileAction = 'view'
          }
        } else {
          this.reconcileAction = 'view'
        }
      } else if (this.transactionInEnvelopeStatuses.includes(transaction.data.TransactionStatus)) {
        if (transaction.data.EnvelopeStatus === 'Draft') {
          this.reconcileAction = 'edit'
        } else if (this.isUserInApprovalList()) {
          this.reconcileAction = 'edit'
        } else {
          this.reconcileAction = 'view'
        }
      } else {
        this.reconcileAction = 'create'
      }
    },
    async getApprovalUsers(envelopeId) {
      await this.api.get(this.api.$.evedpaycard.approvalUsersForEnvelope, {
        params: {
          envelopeId
        }
      })
        .then(response => {
          this.approvalUsersData = response.data
        })
        .catch(error => {
          console.error('There was a problem with the approval users request:', error)
        })
    },
    isUserInApprovalList() {
      const currentUserID = this.$root.getUser.$.user.UserID
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(user => user.Id === currentUserID && user.IsCurrentAction)
      }
      return false
    }
  }
}
</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.navless-layout-header {
  position: fixed !important;
  width: 100%;
  top: 0;
  z-index: 99;
}

.submit-btn {
  padding-left: 20px;
  &.loading:before {
    left: 5px !important;
    right: auto !important;
    color: #fff !important;
  }
}

.reconcile-form >>> {
  .reconcile-transaction-overlay {
    border-radius: 0;
    border: none;
    box-shadow: none;
    padding: 0;

    > p.small {
      display: none;
    }
    .col-md-12 {
      padding-left: 0;
      padding-right: 0;
    }

    .dawn-file-size {
      display: none;
    }

    textarea {
      width: 100%;
    }

    .file-uploads {
      display: block;
      .btn-primary {
        display: block;
        background-color: #007bff;
        color: #fff;
        padding-top: 4px;
        padding-bottom: 4px;
        font-size: 12px;
      }
    }
  }

  .overview-card {
    display: none;
  }

  .full-width-table {
    tbody, thead {
      float: left;
      width: 0;
    }
    tr + tr {
      margin-top: 80px !important;
    }
    tbody tr {
      width: 50%;
      display: block;
      position: relative;
      border-bottom: 1px solid #ddd;
      padding-bottom: 11px;
      width: 90vw;
    }
    td {
      display: block;
      width: 90vw;
      margin-bottom: 8px !important;
    }
    th {
      display: none;
      width: 50%;
      margin-bottom: 60px;
      position: relative;
      top: -40px;
      width: 100vw;
      padding-left: 5px;
    }
    td input.custom-fields {
      padding-left: 14px;
    }
    .form-group.money-input {
      margin-top: 2px;
    }
    td input.custom-fields::placeholder {
      color: #bcbcbc !important
    }
  }

  .split-buttons {
    position: absolute;
    bottom: -40px;
    left: 0;
  }
}

.card {
  border-radius: 6px;
  border-top-width: 0px !important;
  border-right-width: 0px !important;
  border-bottom-width: 0px !important;
  box-shadow: 1px 3px 5px 0px rgba(0,0,0,0.15);

  >>> &.no-icon .icon-wrapper.no-icon {
    min-width: 0;
  }
}

.summary {
  width: 100%;
}

.preview {
  .icon {
    color: #aaa;
    font-size: 64px;
    padding: 0.5rem 1rem 0.5rem 0;
    float: left;
  }
}

.optional-text {
  font-style: italic;
  opacity: 0.7;
}

.custom-button {
  background-color: #007bff;
  color: #fff;
  border: 1px solid #007bff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-button1 {
  background-color: #fff;
  color: black;
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-button:hover {
  background-color: #007bff;
  color: #fff;
}

.overflow-merchant {
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/transactiondetails.vue